module.exports = __webpack_public_path__ + "static/media/65pic.80635f13.jpg";